const TOGGLE_BAR = document.querySelector('.toggle-bar');

const setActiveButton = () => {
	const buttons = TOGGLE_BAR.querySelectorAll('.toggle-bar__button');
	const currentURL = window.location.href;

	buttons.forEach((el) => {
		if (el.href === currentURL) el.classList.add('active');
		else el.classList.remove('active');
	})
}

if (TOGGLE_BAR) setActiveButton();